export const COLOUR_LOGO_SRC = '/bundles/evpticketfrontend/images/logo.png';
export const WHITE_LOGO_SRC = '/bundles/evpticketfrontend/images/logo_white.png';
export const BLACK_LOGO_FILTER = 'brightness(0)';

const COLOUR_LOGO = { src: COLOUR_LOGO_SRC, style: {} };
const WHITE_LOGO = { src: WHITE_LOGO_SRC, style: {} };
const BLACK_LOGO = { src: WHITE_LOGO_SRC, style: { filter: BLACK_LOGO_FILTER } };

export default function resolveBrandLogo(onDarkSurface, highContrast) {
    if (onDarkSurface) {
        return WHITE_LOGO;
    }

    return highContrast ? BLACK_LOGO : COLOUR_LOGO;
}
